import { Injectable } from '@angular/core';

// import { HeroJobAdComponent }   from './hero-job-ad.component';
// import { HeroProfileComponent } from './hero-profile.component';
import { UscFooterComponent } from '../components/usc-store/usc-footer/usc-footer.component';
import { FooterItem } from '../components/footer/footer-item';

@Injectable()
export class FooterService {
    getAvailableFooters() {
    return [
      new FooterItem(UscFooterComponent, {name: 'usc-store-footer'})
    ];
  }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/services/footer.service.ts